import { Card, Tabs } from '@mantine/core'

function StyledTabs(props) {
  return (
    <Card
      p={24}
      radius={4}
      sx={{ backgroundColor: '#0E1922', borderBottom: '2px solid #7B39B6' }}
    >
      <Tabs
        unstyled
        styles={(theme) => ({
          tab: {
            ...theme.fn.focusStyles(),
            backgroundColor: 'transparent',
            border: 0,
            padding: 12,
            fontSize: 16,
            fontWeight: 400,
            color: '#fff',
            cursor: 'pointer',

            '&[data-active]': {
              fontWeight: 700
            }
          },

          tabsList: {
            display: 'flex',
            gap: '12px'
          }
        })}
        {...props}
      />
    </Card>
  )
}

export default StyledTabs
